import React from 'react';
import { Link, LinkProps } from 'react-router-dom';
import styled, { ThemeProps } from 'styled-components';
import { Theme } from '../theme';
import { font, media } from '../theme/base/mixins';
import { StyledDivComponent } from '../types';
import { FontIcon, FontIconSpan } from './FontIcon';
import { SocialIcon, SocialLinks } from './SocialMedia';

export const Sticky = styled.div<{hide?: boolean}>`
  display: none;
  position: fixed;
  z-index: 1040;
  top: 40%;
  transition: left 0.25s;
  left: 100%;

  ${media.large`
    display: block;

    ${(props) => props.hide ? 'left: 120%;' : ''}
  `};
`;

type StickyElementProps = {
  noPointer?: boolean;
  theme?: ThemeProps<Theme>;
  primaryColor?: boolean;
};
export const StickyElement = styled.div<StickyElementProps>`
  ${font(2.2, 2.5, '500')};

  background-color: ${(props) => props.primaryColor ? props.theme.colors.primary : props.theme.colors.stickyBg};
  color: ${(props: ThemeProps<Theme>) => props.theme.colors.white};
  padding: 16px 32px 16px 16px;
  margin: 4px 0;
  box-shadow: -5px 5px 10px -5px rgba(0, 0, 0, 0.75);
  ${(props) => props.noPointer ? '' : 'cursor: pointer;'}
  white-space: nowrap;
  transition: background-color, color, right 0.5s ease-in-out;
  position: relative;
  right: 0;
  margin-left: -65px;

  ${FontIcon}, ${FontIconSpan} {
    line-height: 32px;
    display: inline-block;

    &:before {
      font-size: 38px;
      margin-right: 16px;
      vertical-align: bottom;
    }
  }

  &:hover {
    background-color: ${(props: ThemeProps<Theme>) => props.theme.colors.white};
    color: ${(props: ThemeProps<Theme>) => props.theme.colors.stickyBg};
    right: 100%;
  }

  ${SocialLinks} {
    margin-left: 15px;
    display: inline-block;

    ${SocialIcon} {
      color: ${(props: ThemeProps<Theme>) => props.theme.colors.stickyBg};

      :hover {
        color: ${(props: ThemeProps<Theme>) => props.theme.colors.primaryHover};
      }
    }
  }
`;

export const StickyElementLink: StyledDivComponent<
  LinkProps & StickyElementProps
> = StickyElement.withComponent(({ ...props }: LinkProps) => (
  <Link {...props} />
)).extend`
    display: block;
`;
